import { render, staticRenderFns } from "./requisition_edit.vue?vue&type=template&id=0105756d&scoped=true&"
import script from "./requisition_edit.vue?vue&type=script&lang=js&"
export * from "./requisition_edit.vue?vue&type=script&lang=js&"
import style0 from "./requisition_edit.vue?vue&type=style&index=0&id=0105756d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0105756d",
  null
  
)

export default component.exports